module.exports = __webpack_public_path__ + "images/54f9bd2725912c4ed259aa1c04d13a03.svg";